import Image, { type StaticImageData } from 'next/image';
import React, { type FC } from 'react';

interface FeaturedFilterCardProps {
  image?: StaticImageData;
  smallImage?: boolean;
  onClick?: () => void;
  title: string;
}

export const FeaturedFilterCard: FC<FeaturedFilterCardProps> = ({
  title,
  image,
  smallImage,
  onClick,
}) => {
  return (
    <button
      className="flex h-20 w-full items-center overflow-hidden rounded-xl bg-leland-gray-hover text-left hover:bg-leland-gray-stroke"
      onClick={onClick}
      id="featured_filter_card:filter_button"
    >
      <h3 className="grow pl-6 pr-3 text-lg font-medium">{title}</h3>
      {image ? (
        <div className={`h-full pl-3 ${smallImage ? 'py-4 pr-3' : ''}`}>
          <Image
            className="h-full w-auto"
            src={image}
            alt={`${title} logos`}
            width={234}
            height={182}
          />
        </div>
      ) : null}
    </button>
  );
};
